import { render, staticRenderFns } from "./RelationshipDuration.vue?vue&type=template&id=ecfb7c52"
import script from "./RelationshipDuration.vue?vue&type=script&lang=js"
export * from "./RelationshipDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports